export default __webpack_public_path__ + "static/main3-f66c10c4ad6d01a6bffc5a55bfa75f6b.jpg";